/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  addObservacion ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/etapa-licitacion/add', item, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          if (response.data.nuOk === 0) {
            item = response.data.id
            commit('ADD_OBSERVACION_CASO', item)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  setAllObservacionesCaso ({ commit }, item) {
    return new Promise((resolve, reject) => {
      commit('SET_OBSERVACION_CASO', item)
      resolve(item)
    })
  },
  getAllObservacionesCaso ({ commit }) {
    return new Promise((resolve, reject) => {

      axios.get('/api/etapa-licitacion', {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          commit('SET_OBSERVACION_CASO', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getObservacionCasoByCaso ({ commit }, item) {
    return new Promise((resolve, reject) => {

      axios.get(`/api/etapa-licitacion/${item.IDLICITACION}`, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          commit('SET_OBSERVACION_CASO', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateObservacion ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/etapa-licitacion/update', item, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          if (response.data.nuOk === 0) {
            commit('UPDATE_OBSERVACION_CASO', item)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  removeObservacionCaso ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.post('/api/etapa-licitacion/delete', {id: itemId}, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          if (response.data.nuOk === 0) {
            commit('REMOVE_OBSERVACION_CASO', itemId)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => { reject(error) })
    })
  }
}
